import React, { useEffect } from 'react'
import { Stack } from '@mui/material'
import { useInstallationConfigurationTabs } from 'src/Libs/installations/hooks/installation-configuration/use-installation-configuration-tabs'
import { useProductSerialnumbers } from 'src/Libs/installations/hooks'
import { useEmcStatus } from 'src/Libs/installations/hooks/installation-configuration/em360/use-emc-status'
import { DeviceLinkModel } from 'src/Libs/installations'
import { useQntmStorageList } from 'src/Libs/installation-details/hooks/use-qntm-storage-list'
import StorageSettingsCard from './StorageSettingsCard'

const STORAGE_TAB_INDEX = 2

interface Props {
  installationId?: number
  emcDeviceLink?: DeviceLinkModel
}

const StorageOverview: React.FC<Props> = ({ installationId, emcDeviceLink }) => {
  const { setActiveTab } = useInstallationConfigurationTabs(installationId)

  const [productSerialnumbers] = useProductSerialnumbers(emcDeviceLink?.deviceId ? [emcDeviceLink.deviceId] : undefined)

  const emcSerialnumber = productSerialnumbers[0]?.serialno?.toString()

  const { isOnline: isEmcOnline } = useEmcStatus(emcSerialnumber)
  const { data: qntmStorages, isLoading: isQntmStorageCountLoading } = useQntmStorageList(installationId?.toString() ?? '', emcDeviceLink?.id ?? 0)
  const qntmSerialNumbers = (qntmStorages ?? []).map(storage => storage.deviceName).filter(serial => typeof serial === 'string' && serial.length > 0)

  useEffect(() => {
    setActiveTab(STORAGE_TAB_INDEX)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Stack gap={2}>
      <StorageSettingsCard
        installationId={installationId}
        emcDeviceLinkId={emcDeviceLink?.id}
        emcSerialnumber={emcSerialnumber}
        isEmcOnline={isEmcOnline}
        plannedStorageCount={qntmStorages?.length ?? 0}
        isPlannedStorageCountLoading={isQntmStorageCountLoading}
        qntmSerialNumbers={qntmSerialNumbers}
      />
    </Stack>
  )
}

export default StorageOverview
